import { render, staticRenderFns } from "./biletentegre.vue?vue&type=template&id=547121d8&"
import script from "./biletentegre.vue?vue&type=script&lang=js&"
export * from "./biletentegre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports